import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import UsersLabsForm from '../../../components/UsersLabsForm/UsersLabsForm';
import * as actions from '../../../store/usersLabs/actions';

function EditLab() {
  const connectedUser = useSelector((state) => state.auth?.user?.data);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { usersLab } = useSelector(state => state.usersLabs);

  useEffect(() => {
    if (id) {
      dispatch(actions.getUsersLabRequest(id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  if (connectedUser?.role_id !== 1) {
    return "Your are not authorized to view this page";
  }

  return (
    <div>
        <UsersLabsForm usersLab={usersLab} />
    </div>
  );
}

export default EditLab;
